import React, { Fragment, useState  } from 'react';
import BootstrapRow from "ui/BootstrapRow";

const CollapsibleOutcomeReviewHistory = (props) =>
{
	const [ forceOpen, setForceOpen ] = useState ( false ) ;

	const panelRow = ( row ) =>
	{
		const date_submitted = row.date_submitted == null ? row.date_created : row.date_submitted ;

		return (
			<BootstrapRow key={'caddPanelRow' + row.outcome_review_id} style={{marginBottom: '7px'}}>
				<div key='pr1' className='col-md-3'>{date_submitted}</div>
				<div key='pr2' className='col-md-9'>{row.review_comment}</div>
			</BootstrapRow>
		)
	}

	const panelContent = () =>
	{
		return props.data.filter ( (item) =>
		{
			return item.review_comment != null ;
		}).map ((rec) =>
		{
			return panelRow( rec )
		}) ;
	}

	const reviewCount = () =>
	{
		const count = props.data.reduce((start, val) =>
		{
			return  val.review_comment != null ? start + 1 : start ;
		}, 0 );

		return count ;
	}


	const collapsiblePanelBody = ( id ) =>
	{
		if ( forceOpen === true )
		{
			return React.createElement ( 'div', { key: id, id: id, className: 'panel-collapse collapse in'},
				React.createElement ( 'div', { className: 'panel-body', style: { borderTop: 'unset'}}, panelContent())) ;
		}
		else
		{
			return React.createElement ( 'div', { key: id, id: id, className: 'panel-collapse collapse'},
				React.createElement ( 'div', { className: 'panel-body', style: { borderTop: 'unset'}}, panelContent())) ;
		}
	}

	const collapsiblePanelBodyNew = ( id ) =>
	{
		return (
			<div id={id} className={'panel-collapse collapse' }>
				<div className='panel-body' style={{ borderTop: 'unset'}}>
					{ panelContent() }
				</div>
			</div>
		)
	}

	const onCollapseClick = () =>
	{
	}

	const collapsiblePanelHeading = ( id, title ) =>
	{
	    return React.createElement ( 'div', { key: 'h1', className: 'panel-heading panel-heading-outcome', style: { fontSize: '14px', paddingLeft: '0px', paddingTop: '5px', paddingBottom: '5px', color: '#5e9a5e' }},
			React.createElement ( 'span', { key: 'h2', className: 'panel-title',  style: { fontSize: '14px'} },
				React.createElement ( 'a', {
					onClick: onCollapseClick,
					'data-toggle' : 'collapse',
					href: '#'+id}, title))) ;
	}

	const collapsiblePanelHeadingAndContent = () =>
	{
		if ( reviewCount() == 0  )
		{
			const divStyle = { fontSize: '14px', fontStyle: 'italic', paddingLeft: '0px', paddingTop: '5px', paddingBottom: '5px', color: 'rgb(200, 201, 205)' } ;

			return (
				<div style={divStyle}>There are no review comments to show</div>
			)
		}
		else
		{
			return (
				<Fragment>
					{ collapsiblePanelHeading ( props.cpp_id , "Click here to view previous review comments") }
					{ collapsiblePanelBody ( props.cpp_id )}
				</Fragment>
			)
		}
	}
	
	const collapsibleRow = () =>
	{
		return collapsiblePanelHeadingAndContent() ;
	}

	return collapsibleRow() ;
}

export default CollapsibleOutcomeReviewHistory ;
